import AEM from 'base/js/aem';
import { Popover } from 'bootstrap';
import Glide, { Controls, Autoplay, Keyboard, Swipe } from '@glidejs/glide/dist/glide.modular.esm';
import { onIntersect } from 'base/js/templates/general/onIntersect';
class AnimatedHotspots extends AEM.Component {
    init() {
        this.mobileWidth = 768;
        this.mobile = false;
        this.mobileContent = this.element.querySelector('.mobile-content');
        const base = 10;
        const props = this.props;
        this.hotspots = this.element.querySelector('.hotspots');
        this.background = props.background;
        this.width = parseInt(props.width, base);
        this.height = parseInt(props.height, base);
        this.slides = parseInt(props.slides, base);
        this.spriteParent = this.element.querySelector('.sprite-parent');
        this.currentStep = this.width;
        this.currentSlide = 1;
        this.delta = '-';
        this.scrollPosition = 0;
        this.imageSetup();
        this.heightSetup();
        this.waitingOnAnimRequest = false;
        this.delta = '=';
        const boundHeightSetup = this.heightSetup.bind(this);
        const boundDoSlide = this.doSlide.bind(this);
        if (!this.mobile) {
            window.addEventListener('resize', () => this.debounce(boundHeightSetup));
            if (this.slides !== 1) {
                onIntersect(
                    this.element,
                    () => window.addEventListener('scroll', boundDoSlide),
                    () => window.removeEventListener('scroll', boundDoSlide),
                    false,
                    {
                        threshold: 0.5
                    });
            } else if (this.hotspots) {
                this.showHotspots();
            }
            if (this.hotspots) {
                const pops = this.hotspots.querySelectorAll('.hotspot');
                this.popovers = [ ...pops ].map(trigger => new Popover(trigger,
                    {
                        content: trigger.querySelector('.content'),
                        container: 'body',
                        html: true,
                        trigger: 'focus',
                        placement: trigger.dataset.bsPlacement
                    }
                ));

                // Add scroll event listener to close popovers
                window.addEventListener('scroll', this.handleScroll.bind(this));
            }
        } else {
            this.showMobile();
        }
    }

    /**
	 * Debounce functions for better performance
	 * (c) 2021 Chris Ferdinandi, MIT License, https://gomakethings.com
	 * @param  {Function} fn The function to debounce
	 */
    debounce(fn) {
        if (!this.waitingOnAnimRequest) {
            window.requestAnimationFrame(() => {
                fn();
                this.waitingOnAnimRequest = false;
            });
            this.waitingOnAnimRequest = true;
        }
    }
    showHotspots() {
        if (this.hotspots) {
            this.hotspots.style.display = 'block';
        }
    }
    hideHotspots() {
        if (this.hotspots) {
            this.hotspots.style.display = 'none';
        }
    }
    doSlide() {
        if (window.innerWidth >= this.mobileWidth) {
            const containerY = this.element.getBoundingClientRect().top;
            if (containerY < 0) {
                const frame = Math.abs(containerY);
                const currentFrame = Math.min(this.slides, Math.ceil(frame / this.frameSize));
                if (currentFrame === this.slides) {
                    this.spriteParent.style.backgroundPosition = 'right top';
                    this.showHotspots();
                } else {
                    this.spriteParent.style.backgroundPosition = `${-Math.floor((currentFrame - 1) * this.currentStep) - 1}px top`;
                    this.hideHotspots();
                }
            }
        }
    }

    imageSetup() {
        if (window.innerWidth >= this.mobileWidth) {
            this.spriteParent.style.backgroundImage = `url('${this.background}')`;
        }
    }

    heightSetup() {
        if (window.innerWidth < this.mobileWidth) {
            this.mobile = true;
        }
        if (!this.mobile) {
            this.currentStep = this.spriteParent.clientWidth;
            const imageRatio = this.height / (this.width / this.slides);
            const newHeight = imageRatio * this.currentStep;
            this.spriteParent.style.height = `${ newHeight }px`;
            this.spriteParent.style.minHeight = `${ newHeight }px`;
            if (this.currentSlide === this.slides) {
                this.spriteParent.style.backgroundPosition = 'right top';
            } else {
                this.spriteParent.style.backgroundPosition = `${ -Math.floor((this.currentSlide - 1) * this.currentStep)}px top`;
            }
            this.spriteParent.style.backgroundSize = `auto ${newHeight}px`;
            this.innerHeight = newHeight;
            if (this.slides > 1) {
                this.element.style.height = `${newHeight * 1.5 }px`;
            } else {
                this.element.style.height = `${ this.outerHeight }px`;
            }
            this.frameSize = newHeight / 2 / this.slides;
        }
    }

    animation() {
        this.spriteParent.style.backgroundPosition = `${-Math.floor((this.currentSlide - 1) * this.currentStep)}px top`;
    }
    async showMobile() {
        const mobileHTML = this.mobileContent.content.cloneNode(true);
        this.element.append(mobileHTML);
        this.spriteParent.style.display = 'none';
        const carousel = this.element.querySelector('.glide');
        if (carousel) {
            const modules = {
                Autoplay: Autoplay,
                Keyboard: Keyboard,
                Swipe: Swipe,
                Controls: Controls,
            };
            const options = {
                type: 'carousel',
                perView: 1,
                autoplay: 4000,
                peek: 0,
                keyboard: true,
                animationDuration: 200,
                rewind: true
            };
            const car = new Glide(carousel, options);
            car.mount(modules);

            // Disable control buttons
            const controlButtons = carousel.querySelectorAll('.glide__bullets button');
            controlButtons.forEach(button => {
                button.disabled = true;
                button.style.pointerEvents = 'none';
            });
        }
    }
    hideAllPopovers() {
    	if (this.popovers) {
        	this.popovers.forEach(popover => {
            	popover.hide();
            	// Remove focus from the trigger element
            	const trigger = popover._element;
            	trigger.blur();
        	});
    	}
    }

    handleScroll() {
    	this.hideAllPopovers();
    }
}

export { AnimatedHotspots };
